var _circle, _path, _path2, _circle2, _circle3, _circle4, _circle5, _rect, _circle6, _circle7, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnavailable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 152,
    viewBox: "0 0 172 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.4784,
    cy: 75.3129,
    r: 71.103,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.525 58.5381L171.216 77.3588L164.261 151.414L84.4771 131.366L104.525 58.5381Z",
    fill: "#D2D2D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.807 76.9497L100.843 58.9473C97.4333 63.857 88.6503 76.5406 80.7947 87.9967C72.939 99.4528 59.2463 113.5 53.3818 119.092L135.211 143.231C136.711 142.413 143.067 136.44 156.487 119.092C169.907 101.744 171.625 83.7688 170.807 76.9497Z",
    fill: "#F3F3F3",
    stroke: "#CCCCCC",
    strokeWidth: 0.818293
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.98,
    cy: 78.1775,
    r: 3.27317,
    fill: "#C4C4C4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.1609,
    cy: 95.3611,
    r: 3.27317,
    fill: "#C4C4C4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.341,
    cy: 110.909,
    r: 3.27317,
    fill: "#C4C4C4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.2163,
    cy: 41.0176,
    r: 29.8586,
    transform: "rotate(25.8347 41.2163 41.0176)",
    fill: "#F0F0F0",
    stroke: "#D2D2D2",
    strokeWidth: 0.818293
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.3659,
    height: 2.45488,
    transform: "matrix(1 0 0 -1 31.8062 49.6094)",
    fill: "#C4C4C4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0323,
    cy: 36.108,
    r: 4.50061,
    fill: "#C4C4C4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.9454,
    cy: 36.108,
    r: 4.50061,
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105.523,
    y: 98.1855,
    width: 39.2781,
    height: 1.63659,
    rx: 0.818293,
    transform: "rotate(15.5 105.523 98.1855)",
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 96.957,
    y: 114.769,
    width: 35.5522,
    height: 1.63659,
    rx: 0.818293,
    transform: "rotate(15.5 96.957 114.769)",
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116.306,
    y: 80.6689,
    width: 39.2781,
    height: 1.63659,
    rx: 0.818293,
    transform: "rotate(14.5 116.306 80.6689)",
    fill: "#C4C4C4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailable);
export default __webpack_public_path__ + "static/media/unavailable.9c1897c91636c19caf7e0cda068a19f3.svg";
export { ForwardRef as ReactComponent };